import { VerticalFormGroupComponent } from 'components/shared/FormGroup/VerticalFormGroupComponent';
import { PercentWithUnit } from 'components/shared/Percent/PercentWithUnit';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { PriceImprovementStatus } from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.model';

import { ValidatedActions } from '../actions/Actions.Validated';

export interface PriceImprovementResponseFormProps {
  status: PriceImprovementStatus;
  validatedTradingOffer: number | undefined;
  validatedPriceAdjustment: number | undefined;
  requestedTradingOffer: number | undefined;
  comment?: string;
  onApply: () => void;
  onDiscard: () => void;
}

export const PriceImprovementResponseForm: FC<PriceImprovementResponseFormProps> = ({
  comment,
  status,
  validatedPriceAdjustment,
  requestedTradingOffer,
  validatedTradingOffer,
  onApply,
  onDiscard,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {status === 'Validated' && (
        <div className="row">
          <VerticalFormGroupComponent
            inputId="requestedTradingOffer"
            labelText={formatMessage({ id: 'priceImprovement.requestedTradingOffer' })}
            className="col-4"
          >
            <PercentWithUnit
              e2e="price-negotiation-priceAdjustment"
              id="requestedTradingOffer"
              key="requestedTradingOffer"
              unit="%"
              value={requestedTradingOffer}
              precision={4}
              decimalPadding
              isReadOnly
            />
          </VerticalFormGroupComponent>
          <VerticalFormGroupComponent
            inputId="validatedTradingOffer"
            labelText={formatMessage({ id: 'priceImprovement.validatedTradingOffer' })}
            className="col-4"
          >
            <PercentWithUnit
              e2e="price-negotiation-priceAdjustment"
              id="validatedTradingOffer"
              key="validatedTradingOffer"
              unit="%"
              value={validatedTradingOffer}
              precision={4}
              decimalPadding
              isReadOnly
            />
          </VerticalFormGroupComponent>
          <VerticalFormGroupComponent
            inputId="validatedPriceAdjustment"
            labelText={formatMessage({ id: 'priceImprovement.validatedPriceAdjustment' })}
            className="col-4"
          >
            <PercentWithUnit
              e2e="price-negotiation-priceAdjustment"
              id="validatedPriceAdjustment"
              key="validatedPriceAdjustment"
              unit="%"
              value={validatedPriceAdjustment}
              precision={4}
              decimalPadding
              isReadOnly
            />
          </VerticalFormGroupComponent>
        </div>
      )}
      {comment && (
        <div className="row">
          <VerticalFormGroupComponent
            inputId="traderComment"
            labelText={formatMessage({ id: 'priceImprovement.comment' })}
            className="col-12"
          >
            <textarea
              id="traderComment"
              value={comment}
              readOnly
              className="form-control"
              data-e2e="price-negotiation-comment"
              rows={3}
            />
          </VerticalFormGroupComponent>
        </div>
      )}
      <div className="d-flex flex-row">
        {status === 'Validated' && <ValidatedActions onDiscarded={onDiscard} onApply={onApply} />}
      </div>
    </>
  );
};

PriceImprovementResponseForm.displayName = 'PriceImprovementResponseForm';
